// src/components/MyProductsPage.tsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Edit, Trash2 } from 'lucide-react'; // Icons install karein: npm install lucide-react

const MyProductsPage: React.FC = () => {
    const [products, setProducts] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    // Fetch Function (Same as before)
    const fetchMyProducts = async () => {
        const token = localStorage.getItem('sellerToken');
        if (!token) return;
        try {
            const response = await fetch('/springboot/api/seller/products/my-products', {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (response.ok) setProducts(await response.json());
        } catch (err) { setError("Error loading products."); } 
        finally { setLoading(false); }
    };

    useEffect(() => { fetchMyProducts(); }, []);

    // --- DELETE HANDLER ---
    const handleDelete = async (productId: number) => {
        if (!window.confirm("Are you sure you want to delete this product?")) return;

        const token = localStorage.getItem('sellerToken');
        try {
            const response = await fetch(`/springboot/api/seller/products/${productId}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (response.ok) {
                // List se hatado bina refresh kiye
                setProducts(products.filter(p => p.id !== productId));
                alert("Product deleted successfully");
            } else {
                alert("Failed to delete product");
            }
        } catch (error) {
            alert("Error deleting product");
        }
    };

    if (loading) return <div className="p-10 text-center">Loading...</div>;

    return (
        <div className="p-6 bg-gray-50 min-h-screen">
            <div className="max-w-7xl mx-auto">
                <div className="flex justify-between items-center mb-6">
                    <h1 className="text-2xl font-bold text-gray-800">My Products ({products.length})</h1>
                    <Link to="/add-new-product" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
                        + Add New Product
                    </Link>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {products.map((product) => {
                        const mainImage = product.images && product.images.length > 0 ? product.images[0].imageUrl : null;

                        return (
                            <div key={product.id} className="bg-white rounded-lg shadow hover:shadow-md transition overflow-hidden group">
                                <div className="h-48 bg-gray-200 relative">
                                    {mainImage ? (
                                        <img src={mainImage} alt={product.productName} className="w-full h-full object-cover" />
                                    ) : (
                                        <div className="w-full h-full flex items-center justify-center text-gray-400">No Image</div>
                                    )}
                                    
                                    {/* Action Buttons (Show on Hover) */}
                                    <div className="absolute top-2 right-2 flex space-x-2 opacity-0 group-hover:opacity-100 transition-opacity bg-white/80 p-1 rounded">
                                        <Link to={`/seller/edit-product/${product.id}`} className="p-1 text-blue-600 hover:text-blue-800">
                                            <Edit size={18} />
                                        </Link>
                                        <button onClick={() => handleDelete(product.id)} className="p-1 text-red-600 hover:text-red-800">
                                            <Trash2 size={18} />
                                        </button>
                                    </div>
                                </div>
                                <div className="p-4">
                                    <h3 className="font-bold text-lg text-gray-800 mb-1">{product.productName}</h3>
                                    <p className="text-green-600 font-bold">₹ {product.price}</p>
                                    <div className="mt-2 flex justify-between items-center">
                                         <span className={`px-2 py-1 text-xs rounded ${product.status === 'APPROVED' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}`}>
                                            {product.status}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    );
};
export default MyProductsPage;